export default {
    keyfobs_create_new_driver_key: "New DriverID Tag",
    keyfobs_create_edit_driver_key: "Edit DriverID Tag",
    keyfobs_create_success_message: "The driverID tag has been created",
    keyfobs_update_success_message: "DriverID tag has been edited",
    keyfobs_account: "Account",
    keyfobs_identifier: "Identifier",
    keyfobs_driver: "Driver", 
}